import styled from 'styled-components';

export const CloseButton = styled.button`
  position: fixed;
  top: 20px;
  right: 20px;
  background: none;
  outline: 0;
  border: none;
  cursor: pointer;
  width: 30px;
  height: 30px;
  z-index: 99999;

  &:before,
  &:after {
    position: absolute;
    left: 15px;
    top: 0;
    content: ' ';
    height: 33px;
    width: 2px;
    background-color: ${({ color }) => color || '#fff'};
  }
  &:before {
    transform: rotate(45deg);
  }
  &:after {
    transform: rotate(-45deg);
  }
`;
